import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CreateComponent } from './create/create.component';
import { AuthGuard, SharedModule } from '../shared';
import { StaffService } from './staff.service';
import { SearchComponent } from './search/search.component';
import { ViewComponent } from './view/view.component';
import { EditComponent } from './edit/edit.component';

const staffRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'create-staff',
    component: CreateComponent,
    canActivate: [AuthGuard]
  },{
    path: 'search-staff',
    component: SearchComponent,
    canActivate: [AuthGuard]
  },{
    path: 'view-staff/:id',
    component: ViewComponent,
    canActivate: [AuthGuard]
  },{
    path: 'edit-staff/:id',
    component: EditComponent,
    canActivate: [AuthGuard]
  }
]);


@NgModule({
  imports: [
    SharedModule,
    staffRouting,
    NgbModule.forRoot()
  ],
  declarations: [
    CreateComponent,
    SearchComponent,
    ViewComponent,
    EditComponent
  ],
  providers: [StaffService]
})
export class StaffModule {}



// WEBPACK FOOTER //
// ./src/app/staff/staff.module.ts